import {railStates} from './../../ukrail/ukrail-routes';

export default function TripChangeEuRailTicketService(
    $state,
) {
    'ngInject';

    Object.assign(this, {
        navigateToSearchForm,
    });

    function navigateToSearchForm({selectedChangeable, railRecommendation, tripId, groupTicketsPrice: oldPrice, travellersCount}) {
        const TRIP_TYPE_ONEWAY = 'Oneway';

        const first = selectedChangeable.DepartureStation;
        const last = selectedChangeable.ArrivalStation;
        const departureDate = selectedChangeable.DepartureDate;

        const rebook = {
            tripId,
            oldPrice,
            travellersCount,
            isRoundtrip: railRecommendation.ReturnOrSingle === TRIP_TYPE_ONEWAY,
            arrival: {
                StationCode: last.Code,
                DisplayString: last.Name + ' (' + last.CountryCode + ')',
            },
            departure: {
                date: departureDate,
                StationCode: first.Code,
                DisplayString: first.Name + ' (' + first.CountryCode + ')',
            },
            railRecommendationId: railRecommendation.Id,
            isEuRails: true,
            selectedChangeable,
        };
        $state.go(railStates.ONEWAY, {rebook});
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-change-eurail-ticket/trip-change-eurail-ticket-service.js